import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

const { colors, space, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: space[16],
		justifyContent: 'center',
		minHeight: '100vh',
		padding: space[24],
		textAlign: 'center',
	},
	message: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		margin: 0,
		maxWidth: 480,
	},
});
